import {
  statusSolicitacaoAuditoriaOptions,
  statusSolicitacaoDiferenteAuditoriaOptions,
} from '@enums/StatusSolicitacao/Index';

export function getStatusOptions(flagAuditoria) {
  const isAuditoria = flagAuditoria === true;

  return isAuditoria
    ? statusSolicitacaoAuditoriaOptions
    : statusSolicitacaoDiferenteAuditoriaOptions;
}
